module.exports = {
    ok:'确定',
    wky:'玩客云',
    cancel:'取消',
    close:'关闭',
    yuan: '元',
    
    rule: '规则',
    note: '说明',
    submit: '提交',
    qq:'QQ号',
    delete:'删除',
    refresh:'刷新',
    view:'查看',
    more:'展开',
    less:'收起',
    loadm:'加载更多',
    history:'历史记录',
    phone:'手机号',
    rtn:'返回',
    toofreq:'操作太频繁了',
    isee:'知道了',
    
    confirm:'确认',
    onething_cloud:'玩客云',
    open: '打开',
    reload:'重新加载',
    lang:'zh',
    prompt:'提示'
}



// WEBPACK FOOTER //
// ./js/src/i18n/common/cn.js